import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { TermsAcceptancePage } from './TermsAcceptancePage'

export const AuthComplete = (): React.ReactElement => (
		<Routes>
			<Route path="terms" element={<TermsAcceptancePage />} />
			<Route path="*" element={<Navigate to="terms" replace />} />
		</Routes>
	)
